import { HistoryDatagrid } from "components/HistoryGrid/Grid";
import { AppReferenceManyField } from "components/list/AppReferenceManyField";
import React from "react";

import { OrderArticleHistoryGrid } from "./OrderPricelistHistoryGrid";
import { OrderStatus } from "entities/OrderStatus";


export const HistoryField = ({ children, ...props }) => {
	const sort = props?.record?.status === OrderStatus.DRAFT ? 
		{field: "id", order: "ASC"} : props.sort;

	return (
		<AppReferenceManyField
			{...props}
			sort={sort}
		>
			<HistoryDatagrid children={children} orderRecord={props.record} />
		</AppReferenceManyField>
	);
};

export const OrderPricelistHistoryField = (props) => (
	<AppReferenceManyField
		{...props}
		perPage={-1}
		source="original_id"
		reference="order-pricelist-history"
		target="original_id"
	>
		<HistoryDatagrid
			children={<OrderArticleHistoryGrid />}
			noWraps={true}
			orderRecord={props.record}
		/>
	</AppReferenceManyField>
);

HistoryField.defaultProps = {
	addLabel: true,
	className: "ra-field-datagrid",
};

OrderPricelistHistoryField.defaultProps = {
	addLabel: true,
	className: "ra-field-datagrid",
};
